import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M10 0C4.5 0 0 4.4 0 9.776v6.843c0 1.662 1.3 2.933 3 2.933h1c1.7 0 3-1.27 3-2.933v-2.933c0-1.661-1.3-2.932-3-2.932H2v-.978c0-4.3 3.6-7.82 8-7.82s8 3.519 8 7.82v.978h-2c-1.7 0-3 1.27-3 2.932v2.933c0 1.662 1.3 2.933 3 2.933h1c1.7 0 3-1.27 3-2.933V9.776C20 4.399 15.5 0 10 0M4 12.709c.6 0 1 .39 1 .978v2.932c0 .587-.4.978-1 .978H3c-.6 0-1-.391-1-.978v-3.91zm14 3.91c0 .587-.4.978-1 .978h-1c-.6 0-1-.391-1-.978v-2.932c0-.587.4-.978 1-.978h2z"
    }, null, -1)
  ]))]))
}
export default { render: render }